import SkeletonElement from './SkeletonElement';
import styled from '@xstyled/styled-components';

const MobileSkeletonProductCard = () => {
  return (
    <MobileProductCardBox>
      <SkeletonElement type={'mobileskeletonimage'}></SkeletonElement>
      <SkeletonInfo>
        <SkeletonElement type={'mobileskeletontitle'}></SkeletonElement>
        <SkeletonElement type={'mobileskeletontitle'}></SkeletonElement>
        <SkeletonElement type={'mobileskeletontext'}></SkeletonElement>
        <SkeletonElement type={'mobileskeletontext'}></SkeletonElement>
      </SkeletonInfo>
    </MobileProductCardBox>
  );
};

const MobileProductCardBox = styled.divBox`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.2rem 0.4rem 0.5rem;
  border-radius: 12px;
  border: 0.7px solid #d8d9e5;
  background-color: white;
  font-weight: 500;
  margin-top: 2rem;
  margin-right: 0.5rem;
`;
const SkeletonInfo = styled.div`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
`;

export default MobileSkeletonProductCard;
